

































































































































































































































































































import {Component, Mixins, Watch} from "vue-property-decorator";
import {mapGetters, mapState} from "vuex";
import IAskuePointsByObject from "@/models/consumption-table/AskuePointsByObject.interface";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import AskueConsumptionTable from "@/components/for-turnovers-and-reports-view/AskueConsumptionTable.component.vue";
import InvisibleWall from "@/components/InvisibleWall.vue";
import Page from "@/components/for-page-grid/Page.vue";
import XNotice from "@/components/hoc/SimpleNotice.vue";
import XSlider from "@/components/SimpleSlider.vue";
import DropdownWithDatePickerWithoutRange from "../hoc/DropdownWithDatePickerWithoutRange.vue";
import ConsumedBarChart from "./ConsumedBarChart.vue";
import ConsumedChartAskue from "./ConsumedChartAskue.vue";
import AskueTable from "./AskueTable.vue";
import EventsTable from "./EventsTable.vue";
import {OrganizationConsumption, OrganizationEvents} from "@/models/organization";
import IChosenAsdPointProps from "@/models/consumption-table/ChosenAsdPointProps.interface";
import {channelColors} from "@/lib/askue";
import moment from "moment";

const showDialog = {slider: false, loader: false};

@Component({
  components: {
    AskueConsumptionTable,
    InvisibleWall,
    Page,
    XNotice,
    XSlider,
    DropdownWithDatePickerWithoutRange,
    ConsumedBarChart,
    ConsumedChartAskue,
    AskueTable,
    EventsTable,
  },
  computed: {
    ...mapGetters({
      contractId: "contract/id",
    }),
    ...mapState({asd: "asd"}),
    ...mapGetters("asd", {
      sortedPointsByObject: "sortedPointsByObject",
    }),
    channelColors() {
      return channelColors;
    },
  },
})
class AskueTabContent extends Mixins(AppApiMixin) {
  [x: string]: any;
  dates: string[] = [];
  selectedDate: any;
  consumptionList: OrganizationConsumption[] = [];
  eventsList: OrganizationEvents[] = [];
  tableConsumptionList = [];
  tableHeaders = [];
  tableChannelsIds = [];

  // состояния кнопок меню
  viewMode = "grid";

  // тип данных
  dataType = "reports";

  // тип отчета
  reportType = "month";
  reportDates: string[] = [];
  diffToggle: boolean = true;

  // каналы
  channelToggle: {};
  channelInfo: {};
  // отдельный объект для всплывающей подсказки
  channelInfoItems = {};

  data() {
    const chosenPointProps: IChosenAsdPointProps = {
      id: 0,
      asdId: 0,
      level: 0,
      mode: 0,
      name: "",
      puName:"",
      tuName:""
    };

    return {
      chosenPointProps,
      showDialog: {...{slider: false, loader: false}},
      showNotice: false,
      showWall: false,
      channelToggle: this.channelToggle,
      selectedDate: this.selectedDate
    };
  }

  public updateChosenPoint(data) {
    this.chosenPointProps = data;

    this.updateChannels();
    this.updateTable();
  }

  public onChannelCheckboxClick(id, value) {
    this.updateChart();
  }

  public updateChannels(chart = true) {
    const {contractId, getChannels, updateChart, reportType} = this
    const channelsPayload = {
      contractId,
      asdId: this.chosenPointProps.asdId,
      reportType,
      date: this.selectedDate,
    }
    getChannels(channelsPayload, (channelsList: []) => {
      this.channelToggle = channelsList['initialization'];
      this.channelInfo = channelsList['channels'];
      this.channelInfoItems = channelsList['channels'];
      if (chart) {
        updateChart();
      }
    }).finally(() => {
      showDialog.loader = false;
    });
  }

  public get protectedSortedAskueByObject(): IAskuePointsByObject[] {
    return this.sortedPointsByObject || [];
  }

  @Watch('dataType')
  dataTypeChanged() {
    if (this.dataType == 'events') {
      this.reportType = 'day';
    }
    if (this.dataType == 'reports') {
      this.reportType = 'month';
    }
    this.updateAllElements();
  }

  @Watch('reportType')
  reportTypeChanged() {
    this.updateChannels(false);
  }

  @Watch('diffToggle')
  diffToggleChanged() {
    this.updateAllElements();
  }

  public updateAllElements() {
    if (this.dataType == 'reports') {
      this.updateChart();
      this.updateTable();
    }
    if (this.dataType == 'events') {
      this.updateEvents();
    }
  }

  public updateDate(data) {
    this.selectedDate = data;
    this.updateAllElements();
  }

  public updateTable() {
    const {
      contractId,
      channelToggle,
      reportType,
      diffToggle,
    } = this;
    const tablepayload = {
      contractId,
      asdId: this.chosenPointProps.asdId,
      channelToggle,
      reportType,
      diffToggle,
      selectedDate: this.selectedDate,
    };
    this.getTableAnalysis(
      tablepayload,
      (consumptionList: {}) => {
        this.tableConsumptionList = consumptionList['channels']['data'];
        this.tableHeaders = consumptionList['channels']['names'];
        this.tableChannelsIds = consumptionList['channels']['ids']
      }
    ).finally(() => {
      showDialog.loader = false;
    });
  }


  public mounted() {
    this.getContractPoints(this.contractId);
    this.updateChannels();
    this.updateTable();
  }

  public closeAllDialogs() {
    this.showDialog = {...showDialog};
  }

  public updateChart() {
    const {
      contractId,
      point_id: objId,
      dates,
      channelToggle,
      reportType,
      diffToggle,
    } = this;
    const [from, to] = dates;
    const tablePayload = {
      contractId,
      asdId: this.chosenPointProps.asdId,
      channelToggle,
      reportType,
      diffToggle,
      selectedDate: this.selectedDate,
    };

    this.getChannelsList(
      tablePayload,
      (consumptionList: {}) => {
        this.consumptionList = consumptionList['channels']['data'];
      }
    ).finally(() => {
      showDialog.loader = false;
    });
  }

  public updateEvents() {
    const payload = {
      contractId: this.contractId,
      asdId: this.chosenPointProps.asdId,
      selectedDate: moment(this.selectedDate).format('YYYY-MM-DD'),
    };

    this.getEventsList(
      payload,
      (eventsList) => {
        this.eventsList = eventsList;
      }
    ).finally(() => {
      showDialog.loader = false;
    });
  }
}

export default AskueTabContent;
